export default "__VITE_ASSET__IEt_Y8Yx__"